import { loadScript } from '@cp/utils/browser/script';
import { AsyncIntegration } from '../asyncIntegration';
import { ISemanticEvent, SemanticContext } from '../semanticEvents';

export type GoogleTagManagerOptions = {
  containerId: string;
  defaultCurrency?: string;
  noConflict?: boolean;
};

export class GoogleTagManager extends AsyncIntegration {
  private options: GoogleTagManagerOptions;
  constructor(
    options: GoogleTagManagerOptions,
    private readonly global: any,
    ctx?: SemanticContext,
  ) {
    super('GoogleTagManager');
    this.options = Object.assign({ noConflict: false }, options);
    this.init(ctx);
  }

  protected _trackEvent(event: ISemanticEvent) {
    // empty
  }

  isLoaded() {
    const window = this.global;
    return !!(window.dataLayer && Array.prototype.push !== window.dataLayer.push);
  }

  async load(): Promise<void> {
    const containerId = this.options.containerId;
    const lib = `//www.googletagmanager.com/gtm.js?id=${containerId}&l=dataLayer`;
    await loadScript(lib);
  }

  init(ctx?: SemanticContext): Promise<void> {
    return this.load()
      .then(() => {
        const window = this.global;

        window.dataLayer = window.dataLayer || [];
        if (this.options.containerId && this.options.noConflict === false) {
          window.dataLayer.push({
            'gtm.start': Date.now(),
            event: 'gtm.js',
          });
        }
      })
      .then(this.onReady.bind(this))
      .catch(this.onInitFail.bind(this));
  }
}
